var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.479,
    height: 21.665,
    viewBox: "0 0 19.479 21.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "report",
    d: "M16.071,17.546A1.043,1.043,0,0,1,15,16.478V1.068a1.068,1.068,0,1,1,2.136,0v15.41A1.074,1.074,0,0,1,16.071,17.546Zm-12.613,0A1.043,1.043,0,0,1,2.39,16.478V10.833a1.068,1.068,0,0,1,2.136,0v5.645A1.074,1.074,0,0,1,3.458,17.546Zm6.256,0a1.043,1.043,0,0,1-1.068-1.068V5.8a1.068,1.068,0,0,1,2.136,0v10.68A1.043,1.043,0,0,1,9.714,17.546Zm8.7,4.119H1.068a1.068,1.068,0,1,1,0-2.136H18.411a1.068,1.068,0,1,1,0,2.136Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.e2a86aad4bead55819fec741b4b9b753.svg";
export { ForwardRef as ReactComponent };